// extracted by mini-css-extract-plugin
var _1 = "styles-module__ConsentDeleted___QTKn3";
var _2 = "styles-module__ConsentDeleted_content___Z_UkW";
var _3 = "styles-module__ConsentDeleted_icon___RseXy";
var _4 = "styles-module__ConsentDeleted_iconPosition___u2uo2";
var _5 = "styles-module__ConsentDeleted_iconWrapper___YCanW";
var _6 = "styles-module__ConsentDeleted_message___s2KAs";
export { _1 as "ConsentDeleted", _2 as "ConsentDeleted_content", _3 as "ConsentDeleted_icon", _4 as "ConsentDeleted_iconPosition", _5 as "ConsentDeleted_iconWrapper", _6 as "ConsentDeleted_message" }
